import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import GoogleThirdBtnProtogenesis1 from "../ui/GoogleThirdBtnCustom";
import EmailLoginBtn from "../ui/EmailLoginBtn";
import { useTranslation } from "react-i18next";
import { LoginBackIcon } from "@/components/icons";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useElapsedTime } from "@/utils/useElapsedTime";
import { useRouter } from "next/router";
const Dropdown = ({
  goEmailLogin,
  onClose,
}: {
  goEmailLogin: () => void;
  onClose: () => void;
}) => {
  const router = useRouter();
  const pageId = "HalfLaunchPage_web";
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const getElapsed = useElapsedTime();
  const handleLeft = () => {
    console.log("handleLeft---first-banner----");
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageLeave",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
      UM_Key_Duration: getElapsed(),
    });
  };
  useEffect(() => {
    console.log("router -----", router.route);
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageView",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
    });
  }, []);
  useEffect(() => {
    return () => {
      setIsOpen(false);
      handleLeft();
    };
  }, []);

  return (
    <div className="flex flex-col items-center w-[calc(100vw-40px)] mt-[16px] ">
      <div className="text-[18px] font-['Mulish'] font-[900] text-[#333] mb-[20px]">
        {t("login.getStart")}
      </div>
      <GoogleThirdBtnProtogenesis1
        onSetThirdPsw={() => {}}
        pageId={pageId}
        buttonName="continuewithgoogle"
        onFinish={() => {
          onClose();
        }}
      />
      {/* 开关按钮 */}

      {isOpen ? null : (
        <div
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <LoginBackIcon></LoginBackIcon>
        </div>
      )}

      {/* 展开内容 */}
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="overflow-hidden"
            style={{ width: "100%" }}
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2, delay: 0.1 }}
            >
              <EmailLoginBtn
                goEmailLogin={() => {
                  handleLeft();
                  goEmailLogin();
                }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Dropdown;
